import { ComponentPropsWithRef } from "react";
import styled from "styled-components";

// TEXT

// STYLES
export const Container = styled.div`
  width: 100%;
  touch-action: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;

  * {
    -webkit-user-drag: none;
  }
`;

// DATA

// TYPES
export type Props = ComponentPropsWithRef<"div">;

// CONSTANTS

// FUNCTIONS

// ASSETS
